
<ngx-slider [options]="options"
            [(value)]="selectedMin"
            [(highValue)]="selectedMax"
            (userChange)="onChange()"
            (userChangeEnd)="onChange()">
</ngx-slider>
